import { IconButton, Theme } from '@nextgen-web-framework/all';
import VideoSection from '../../VideoSection/VideoSection';
import type { VideoModalProps } from '../types/propsTypes';
import styles from './VideoModal.module.scss';

const VideoModal = (props: VideoModalProps) => (
  <div className={`${styles['modal-container']}`} data-testid="video-modal-testid">
    <div className={`${styles['modal-content']}`}>
      <div className={`${styles['modal-close-icon']}`}>
        <IconButton
          iconName="close"
          iconWithBorder
          onClick={() => {
            props.onClose();
          }}
          theme={Theme.BLACK}
          containerClassName={styles['icon-container-overwrite']}
        />
      </div>
      <VideoSection {...props.videoSection} autoPlay={true} />
    </div>
  </div>
);

export default VideoModal;
